import React, { PureComponent } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { formatTextFloat, formatVolume } from '../../../../helpers/Text';
import { REDUCER_NAME } from '../reducer';

class TotalVolume extends PureComponent {
  getTotalBUSD = () => {
    const { data } = this.props;
    const total = {
      totalBu: 0,
      totalSd: 0,
    };
    const firstRow = Object.values(data)[0];
    if (firstRow) {
      total.totalBu = firstRow.sumTotalVolumeBuyUp;
      total.totalSd = firstRow.sumTotalVolumeSellDown;
    }

    return total;
  };

  render() {
    const { totalBu, totalSd } = this.getTotalBUSD();

    return (
      <div className="total-bu-sd d-flex mb-10">
        <div className="mr-16">
          {I18n.t('tasignals.aggressiveContent.totalVol')}
        </div>
        <div className="d-flex mr-30 bu">
          <div className="label">
            {I18n.t('tasignals.aggressiveContent.bu')}
          </div>
          <div className="value">
            {formatTextFloat(formatVolume(totalBu), 2, true)}
          </div>
        </div>

        <div className="d-flex sd">
          <div className="label">
            {I18n.t('tasignals.aggressiveContent.sd')}
          </div>
          <div className="value">
            {formatTextFloat(formatVolume(totalSd), 2, true)}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
  data: state[REDUCER_NAME].listObjectDeceptiveAggressiveDataByTicker,
});

export default connect(mapStateToProps)(TotalVolume);
